


function ExtendBountyDateIcon() {
    return (
       <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
<path d="M19 19V8H5V19H19ZM16 1H18V3H19C19.5304 3 20.0391 3.21071 20.4142 3.58579C20.7893 3.96086 21 4.46957 21 5V19C21 20.11 20.11 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 3.89 3.89 3 5 3H6V1H8V3H16V1ZM11 9.5H13V12.5H16V14.5H13V17.5H11V14.5H8V12.5H11V9.5Z" fill="#5E5E5E"/>
</svg>
    );
}

export default ExtendBountyDateIcon;
